import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {compose} from 'redux';
import AppButton from '../../../components/app-button';
import {Column, Row} from '../../../components/layout';
import {setWizard} from '../../../store/actions';
import colors from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import BubbleMedicoOnline from '../../services/bubble-medico-online';
import './styles.scss';
import AuthorizedImage from '../../../components/images';

// ir buscar strings ao BO
const labels = strings.pt.services;
interface MedicoOnlineProps {
  selectedBu?: any;
  availableBus?: any;
  wizard?: any;
  buStyles: any;
  setWizard(value: any): void;
  labels?: typeof strings.pt.services;
  medicoOnline: any;
  medicoOnlineDisabled: boolean;
  visible?: boolean;
  setLoaded: Function;
}

function MedicoOnline({
  medicoOnline,
  medicoOnlineDisabled,
  visible = true,
  setLoaded,
}: MedicoOnlineProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  useEffect(() => {
    if (visible) {
      setLoaded(!!medicoOnline);
    } else {
      setLoaded(true);
    }

    return () => {
      setLoaded(false);
    };
  }, [visible, medicoOnline]);

  const history = useHistory();
  const bubbleImage = `${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${medicoOnline?.image}`;

  return (
    <Row className="services-container medico-online-container">
      {windowWidth > 768 ? (
        <>
          {medicoOnline && !medicoOnlineDisabled && visible && (
            <>
              <Column>
                <Row className="services-row-images-container">
                  <Column className="medico-online-column-images-container">
                    <Row className="services-row-images-display">
                      <BubbleMedicoOnline
                        classNames={'medico-online-bubble-image'}
                        height={'300px'}
                        width={'300px'}
                      />
                      <AuthorizedImage
                        source={bubbleImage}
                        className="medico-online-image"
                      />
                    </Row>
                  </Column>
                </Row>
              </Column>
              <Column className="medico-online-titlecolumn">
                <Row
                  className="medico-online-heading1"
                  style={{...fonts.XL, ...fonts.Bold}}>
                  {medicoOnline?.serviceName}
                </Row>
                <Row
                  className="medico-online-subtitle"
                  style={{...fonts.Bold, color: colors.black}}>
                  {medicoOnline?.subTitle}
                </Row>
                <Row
                  className="medico-online-description"
                  style={{...fonts.MM, ...fonts.Medium, color: colors.black}}>
                  {medicoOnline?.listDescription}
                </Row>
                <Row>
                  <AppButton
                    variant="primary"
                    className="medico-online-button"
                    onClick={() => history.push('/consultas-online')}>
                    {medicoOnline?.buttonText}
                  </AppButton>
                </Row>
              </Column>
            </>
          )}
        </>
      ) : (
        <>
          {medicoOnline && !medicoOnlineDisabled && visible && (
            <Column>
              <Row className="medico-online-image-responsive-container">
                <Row className="services-row-images-container">
                  {medicoOnline && (
                    <Column className="medico-online-column-images-container">
                      <Row className="services-row-images-display">
                        <BubbleMedicoOnline
                          classNames={'medico-online-bubble-image'}
                          height={'280px'}
                          width={'280px'}
                        />
                        <AuthorizedImage
                          source={bubbleImage}
                          className="medico-online-image"
                        />
                      </Row>
                    </Column>
                  )}
                </Row>
              </Row>
              <Row className="medico-online-heading1" style={{...fonts.Bold}}>
                {medicoOnline?.serviceName}
              </Row>
              <Row
                className="medico-online-subtitle"
                style={{...fonts.S, ...fonts.Medium, color: colors.black}}>
                {medicoOnline?.subTitle}
              </Row>
              <Row
                className="medico-online-description"
                style={{...fonts.MM, color: colors.black}}>
                {medicoOnline?.listDescription}
              </Row>
              <Row className="medico-online-button-row">
                <AppButton
                  variant="primary"
                  className="medico-online-button"
                  onClick={() => history.push('/consultas-online')}>
                  {medicoOnline?.buttonText}
                </AppButton>
              </Row>
            </Column>
          )}
        </>
      )}
    </Row>
  );
}

const mapStateToProps = ({selectedBu, strings, wizard, globalStyles}: any) => ({
  selectedBu: selectedBu.value,
  labels: strings.value.pt.services,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MedicoOnline)
);
